import isString from 'lodash/isString';

function extractFileNameFromWindowsPath(path) {
    if (!isString(path)) {
        throw new Error(`${path} is not a string`);
    }
    const matches = path.match(/^[A-Za-z]+?:\\/);
    const isWindowsFilePath = matches !== null && matches.length >= 1;
    if (!isWindowsFilePath) return path;
    const pathChunks = path.split('\\');
    return pathChunks[pathChunks.length - 1].trim();
}

export { extractFileNameFromWindowsPath };
